import { FadeUp } from "@/components/Reveal";
import { HeartHandshake, MapPin, TrendingUp } from "lucide-react";
import { TEAM_IMAGE } from "@/data/site";

const About = () => (
  <section id="about" className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-12 lg:py-32" data-testid="about-section">
    <div className="grid items-center gap-14 lg:grid-cols-2">
      <FadeUp>
        <p className="mono text-xs uppercase tracking-[0.2em] text-[#E9C766] sm:text-sm">About us</p>
        <h2 className="font-display mt-4 text-xl font-bold tracking-tight text-white sm:text-2xl lg:text-3xl">
          Family roots. <span className="text-[#D9A92E]">Big-league tech.</span>
        </h2>
        <div className="mt-6 space-y-4 text-base leading-relaxed text-[#A1A1AA]">
          <p>
            Family Based Technology business started in South Florida in 2017. We are focused more
            towards helping the small and mid size business. Our work might look expensive but our
            price is not.
          </p>
          <p>
            We make technology easy for the start ups and small business size which can help them
            scale without digging a deep hole in their pocket. We use the power of outsourcing to
            make it cost effective to our client while making sure we add value and help our
            customers grow.
          </p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <span className="flex items-center gap-2 rounded-full border border-white/10 bg-[#131316] px-4 py-2 text-xs text-white">
            <MapPin className="h-3.5 w-3.5 text-[#D9A92E]" /> Est. 2017 — South Florida
          </span>
          <span className="flex items-center gap-2 rounded-full border border-white/10 bg-[#131316] px-4 py-2 text-xs text-white">
            <HeartHandshake className="h-3.5 w-3.5 text-[#D9A92E]" /> Family-based team
          </span>
          <span className="flex items-center gap-2 rounded-full border border-white/10 bg-[#131316] px-4 py-2 text-xs text-white">
            <TrendingUp className="h-3.5 w-3.5 text-[#D9A92E]" /> Built for small & mid-size business
          </span>
        </div>
      </FadeUp>
      <FadeUp delay={0.15}>
        <div className="relative overflow-hidden rounded-2xl border border-white/10">
          <img
            src={TEAM_IMAGE}
            alt="The Spark Plug team working together"
            loading="lazy"
            className="h-[380px] w-full object-cover lg:h-[460px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#131316] via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 rounded-xl border border-white/10 bg-[#09090B]/80 p-5 backdrop-blur-xl">
            <p className="mono text-[10px] uppercase tracking-[0.2em] text-[#E9C766]">Since 2017</p>
            <p className="mt-1.5 text-sm font-medium text-white">
              Premium-looking work, small-business pricing — that's the Spark Plug promise.
            </p>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default About;
